import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { environment } from 'src/environments/environment';
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { loadStripe, Stripe, StripeElements } from '@stripe/stripe-js';
import { DialogData } from 'listing-angular15';

@Component({
  selector: 'app-perennial-mandalism-dashboard',
  templateUrl: './perennial-mandalism-dashboard.component.html',
  styleUrls: ['./perennial-mandalism-dashboard.component.scss'],
})
export class PerennialMandalismDashboardComponent {
  public memberShipData: any = {};
  public blogData: any = {};
  public mainBlog: any = {};
  public videoData: any = {};
  public mainVideo: any = {};
  public progressLoader: boolean = false;
  public cookieData: any = {};
  public api_url_for_managebanner = environment.api_url;
  public jwttokenformanagebanner = '';
  public contentArray: any = [];
  public contentCount: any;
  public loader: boolean = false;
  public subscribeLoader: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  currentFileName: string = '';

  constructor(
    private sanitizer: DomSanitizer,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    public cookieService: CookieService,
    private apiservice: ApiservicesService,
    private renderer: Renderer2,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this.cookieData = JSON.parse(
      this.cookieService.getAll()['login_user_details']
    );
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe((response: any) => {
      console.log('activatedRoute', response);
      if (response.response.status === 'success') {
        this.memberShipData = response?.response?.result;
        console.log(this.memberShipData);
      }
    });

    // this.membershipData();
    // this.membershipData();
    this.getContentCount();
    this.getDashboardContent();
    // this.getBlogData();
    // this.getVideoData();
  }

  membershipData() {
    this.apiservice
      .getHttpDataPost('user/fetch-membership-details', {
        user_cognito_id: '51e726d5-5336-4fe3-aa87-e4de14613188',
      })
      .subscribe((response: any) => {
        this.memberShipData = response.result;
      });
  }

  getBlogData() {
    this.apiservice
      .getHttpDataPost('blogmanagement/list-for-front-end', {
        condition: { limit: 10, skip: 0 },
        searchcondition: {},
        sort: { type: 'desc', field: 'created_on' },
        project: {},
        token: '',
      })
      .subscribe((response: any) => {
        this.blogData = response.results.list;
        this.mainBlog = response.results.list[0];
      });
  }

  getVideoData() {
    this.apiservice
      .getHttpDataPost('videomanagement/list-for-front-end', {
        condition: { limit: 10, skip: 0 },
        searchcondition: {},
        sort: { type: 'desc', field: 'created_on' },
        project: {},
        token: '',
      })
      .subscribe((response: any) => {
        this.videoData = response.results.list;
        this.mainVideo = response.results.list[0];
      });
  }

  htmlSanitaizer(val: any) {
    let value = this.sanitizer.bypassSecurityTrustHtml(val);
    return value;
  }

  videoPlayer(obj: any): any {
    let videoValue = obj[0]; // assuming you want to show the first video
    if (videoValue.videotype == 1) {
      return this.htmlSanitaizer(
        `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoValue.youtube_link}" title="${videoValue.youtube_title}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
      );
    } else if (videoValue.videotype == 3) {
      const videoFile = videoValue.videofile[0];
      return this.htmlSanitaizer(
        `<video width="560" height="315" controls>
          <source src=" https://awsbackend-dev-patient-files-test.s3.amazonaws.com/${videoFile.baseurl}${videoFile.fileservername}" type="${videoFile.type}">
          Your browser does not support the video tag.
        </video>`
      );
    }
    // https://awsbackend-dev-patient-files-test.s3.amazonaws.com/practicepresence-cancer-backend-angular/blogvideo/blogvideo-17280414639321851190-uhd_3840_2160_25fps.mp4
    return null; // if no valid video type is found
  }

  getDashboardContent() {
    this.loader = true;
    let reqBody = {
      searchcondition: {},
      sort: { type: 'asc', field: 'priority' },
      project: {},
      token: '',
    };
    this.apiservice
      .getHttpDataPost('content/content-list-for-frontend', reqBody)
      .subscribe({
        next: (response) => {
          console.log(response, 'response');
          if (response.status == 'success') {
            this.contentArray = response?.results?.res
              ? response.results.res
              : [];
            this.loader = false;
            console.log(this.contentArray, 'tabledata');
          }
        },
        error: (error) => {
          this.loader = false;
        },
      });
  }

  getContentCount() {
    this.apiservice.getHttpData('content/content-type-counts').subscribe({
      next: (response) => {
        console.log(response);
        this.contentCount = response.counts;
        console.log(response);
      },
      error: (error) => {},
    });
  }

  getThumbnail(item: any): string {
    return (
      item.thumbnail_path?.baseurl + item.thumbnail_path?.fileservername ||
      'default-thumbnail.png'
    );
  }

  getDocumentUrl(item: any): string {
    return item.file_path?.baseurl + item.file_path?.fileservername;
  }

  // playVideo(item: any) {
  //   if (item.file_path) {
  //     window.open(
  //       item.file_path.baseurl + item.file_path.fileservername,
  //       '_blank'
  //     );
  //   }
  // }

  getSanitizedYouTubeUrl(url: string, isPlaying: boolean): SafeResourceUrl {
    if (!url) return '';

    const embedUrl = `https://www.youtube.com/embed/${url}`;
    const autoplayUrl = isPlaying ? `${embedUrl}?autoplay=1&mute=1` : embedUrl;

    return this.sanitizer.bypassSecurityTrustResourceUrl(autoplayUrl);
  }

  sanitizeUrlRaw(url: string): SafeUrl {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url; // Ensure proper URL format
    }
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getSanitizedYouTubeUrlFullUrl(
    url: string,
    isPlaying: boolean
  ): SafeResourceUrl {
    console.log(url, isPlaying, 'testsanket');
    if (!url) return '';
    const videoId = this.extractYouTubeVideoId(url);
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
    const autoplayUrl = isPlaying ? `${embedUrl}?autoplay=1&mute=1` : embedUrl;
    return this.sanitizer.bypassSecurityTrustResourceUrl(autoplayUrl);
  }

  getSanitizedYouTubeFullUrlEmbed(
    url: string,
    isPlaying: boolean
  ): SafeResourceUrl {
    console.log(url, isPlaying);
    if (!url) return '';
    const autoplayUrl = isPlaying ? `${url}&autoplay=1&mute=1` : url;
    return this.sanitizer.bypassSecurityTrustResourceUrl(autoplayUrl);
  }

  extractYouTubeVideoId(url: string): string {
    const videoIdMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/
    );
    return videoIdMatch ? videoIdMatch[1] : '';
  }

  isYouTubeUrl(url: string): boolean {
    return (
      !!url && typeof url === 'string' && url.toLowerCase().includes('youtube')
    );
  }

  shouldShowVideo(item: any): boolean {
    return (
      ((item.direct_url && !this.isYouTubeUrl(item.direct_url)) ||
        (item.embed_url && !this.isYouTubeUrl(item.embed_url))) &&
      item.isPlaying
    );
  }

  shouldShowIframe(item: any): boolean {
    return (
      ((item.direct_url && this.isYouTubeUrl(item.direct_url)) ||
        (item.embed_url && this.isYouTubeUrl(item.embed_url))) &&
      item.isPlaying
    );
  }

  playVideo(item: any) {
    this.contentArray.forEach((i: any) => {
      if (i !== item) {
        i.isPlaying = false;
      }
    });

    item.isPlaying = !item.isPlaying;
  }

  redirecttoAditionalpage() {
    // if (this.memberShipData.memberCount > 0) {
      this.router.navigateByUrl(
        `/perennial-mandalism-dashboard/additional_member`
      );
    // } else {
    //   this.matSnackBar.open('No additional member has been added yet.', '', {
    //     duration: 3000,
    //   });
    // }
  }

  // << ------------- Search Functions ------------- >>

  refreshFields(): void {
    this.startDate = null;
    this.endDate = null;
    this.getDashboardContent();
    this.matSnackBar.open('New Range of Data Loaded !!', '', {
      duration: 10000,
    });
  }

  search(): void {
    this.loader = true;
    let payload = {
      searchcondition: {
        display_dates: {} as
          | Partial<{ $gte: number; $lte: number }>
          | undefined,
      },
      sort: { type: 'asc', field: 'priority' },
      project: {},
      token: '',
    };

    if (this.startDate) {
      payload.searchcondition.display_dates =
        payload.searchcondition.display_dates || {};
      payload.searchcondition.display_dates.$gte = Math.floor(
        this.startDate.getTime()
      );
    }

    if (this.endDate) {
      payload.searchcondition.display_dates =
        payload.searchcondition.display_dates || {};
      payload.searchcondition.display_dates.$lte = Math.floor(
        this.endDate.getTime()
      );
    }

    if (
      payload.searchcondition.display_dates &&
      Object.keys(payload.searchcondition.display_dates).length === 0
    ) {
      payload.searchcondition.display_dates = undefined;
    }

    this.apiservice
      .getHttpDataPost('content/content-list-for-frontend', payload)
      .subscribe({
        next: (response) => {
          console.log(response);
          if (response.status == 'success' && response.results.res.length > 0) {
            this.contentArray = [];
            this.contentArray = response.results.res;
            this.matSnackBar.open('New Range of Data Loaded !!', '', {
              duration: 10000,
            });
          } else {
            this.matSnackBar.open('No Data Found in this Range !!', '', {
              duration: 10000,
            });
          }

          this.loader = false;
        },
        error: (error) => {
          this.matSnackBar.open('Something Went Wrong !!', '', {
            duration: 10000,
          });
          this.loader = false;
        },
      });
  }

  registerClick() {
    this.router.navigateByUrl(
      `/mysteryschool-signup/${this.cookieData.userinfo._id}`
    );
  }

  // << ------------------- File Download Directly ----------- >>

  async downloadFile(item: any) {
    const fileUrl = `https://d37pbainmkhx6o.cloudfront.net/${item.file_path.baseurl}${item.file_path.fileservername}`;
    this.currentFileName = item.file_path.name;

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = this.currentFileName;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      this.matSnackBar.open(`Downloading ${this.currentFileName}...`, 'Close', {
        duration: 5000,
      });
    } catch (error) {
      console.error('Error downloading file:', error);
      this.matSnackBar.open('Failed to download file', 'Close', {
        duration: 5000,
      });
    }
  }

  unsubscribeOpen() {
    if (!this.cookieData?.userinfo?.perennial_subscription_id) {
      this.matSnackBar.open(
        'Subscription information is missing. Cannot proceed.',
        '',
        { duration: 5000 }
      );
      return;
    }

    const dialogRef = this.dialog.open(PerennialSubscriptionModal, {
      panelClass: ['custom-modalbox', 'mystery-subscription-modalbox'],
      data: {
        subscription_id: this.cookieData.userinfo.perennial_subscription_id,
        expiry_date: this.cookieData.userinfo.perennial_current_period_end,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed with result:', result);
      if (result === true) {
        let oldcookie = JSON.parse(
          this.cookieService.get('login_user_details')
        );
        let newcookie = {
          lastLoginTime: oldcookie.lastLoginTime,
          token: oldcookie.token,
          token_expiry: oldcookie.token_expiry,
          userinfo: {
            ...oldcookie.userinfo,
            perennial_subscription_status: false,
          },
        };
        console.log('newcookie', newcookie);
        this.cookieService.set(
          'login_user_details',
          JSON.stringify(newcookie),
          { path: '/' }
        );
        this.cookieData = newcookie;
        this.matSnackBar.open(
          'Unsubscription initiated successfully. Access remains until expiry.',
          'Ok',
          { duration: 5000 }
        );
      }
    });
  }

  subscribeOpen() {
    this.subscribeLoader = true;
    const body = {
      customer_id: this.cookieData.userinfo._id,
      email: this.cookieData.userinfo.email,
    };

    this.apiservice
      .getHttpDataPost('cart_management/subscription-payment', body)
      .subscribe({
        next: (response: any) => {
          console.log('response', response);

          if (response.status === 'success' && response.results) {
            let dataObj = {
              clientSecret: response.clientSecret,
              customerId: response.customerId,
              subscriptionId: response.subscriptionId,
              setupIntentClientSecret:response.setupIntentClientSecret,
            };
            this.subscribeLoader = false;
            console.log('response.results perennial', dataObj);

            this.openStripeModal({ ...dataObj, ...body });
          } else {
            this.subscribeLoader = false;
            this.matSnackBar.open(
              response.message ||
                'Failed to initiate subscription. Please try again.',
              'Close',
              { duration: 5000 }
            );
          }
        },
        error: (error: any) => {
          this.subscribeLoader = false;
          const errorMessage =
            error?.error?.message ||
            'An error occurred while initiating subscription.';
          this.matSnackBar.open(errorMessage, 'Close', { duration: 5000 });
        },
      });
  }

  private openStripeModal(dataObj: any): void {
    console.log('dataObj perrenial', dataObj);

    const dialogRef = this.dialog.open(PerennialStripeModal, {
      panelClass: ['custom-modalbox', 'stripe-modalbox'],
      data: {
        dataObj: dataObj,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('AuthGuard: Stripe Modal closed with result:', result);
    });
  }
}

// << ------------------ Subscription Modal ------------------ >>

@Component({
  selector: 'PerennialSubscriptionModal',
  templateUrl: './perennial-subscription-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class PerennialSubscriptionModal {
  public prevData: any;

  constructor(
    public dialogRef: MatDialogRef<PerennialSubscriptionModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public matSnackBar: MatSnackBar,
    private apiService: ApiservicesService
  ) {
    this.prevData = data;
  }

  public isLoading: boolean = false;

  ngOnInit() {}

  public unsubscribe() {
    this.isLoading = true;
    const payload = {
      subscription_id: this.prevData.subscription_id,
    };
    const endpoint = 'stripe/unsubscribe-stripe-Perennial';

    this.apiService.getHttpDataPost(endpoint, payload).subscribe({
      next: (response: any) => {
        console.log('Unsubscribe response:', response);
        this.dialogRef.close(true);
        this.isLoading = false;
      },
      error: (error: any) => {
        const errorMessage = 'Failed to unsubscribe. Please try again.';
        this.matSnackBar.open(errorMessage, '', {
          duration: 5000,
        });
        this.isLoading = false;
        this.closeModal();
      },
    });
  }

  public closeModal() {
    this.dialogRef.close(false);
  }
}

// << ------------------ Stripe Perennial Comp ------------------ >>

@Component({
  selector: 'PerennialStripeModal',
  templateUrl: './perennialStripeModal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule, CommonModule],
})
export class PerennialStripeModal implements OnInit {
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  clientSecret: string = '';
  public modalData: any = null;
  public stripeData: any = null;
  isLoading: boolean = false;
  public cookieData: any = {};
  setupIntentClientSecret: string = '';
  mode: 'payment' | 'setup' | 'noClientSecret' | undefined;

  constructor(
    public dialogRef: MatDialogRef<PerennialStripeModal>,
    private apiService: ApiservicesService,
    @Inject(MAT_DIALOG_DATA) public data: { index: any; item: any },
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    public cookieService: CookieService,
    private cdr: ChangeDetectorRef
  ) {
    this.modalData = data;
    this.cookieData = JSON.parse(
      this.cookieService.getAll()['login_user_details']
    );
  }

  public userformdata: any = null;
  async ngOnInit() {
    console.log('this.modalData.dataObj_new', this.modalData);
    if (!this.modalData || !this.modalData.dataObj) {
      console.error('Modal data or dataObj is missing!');
      this.mode = 'noClientSecret';
      return;
    }

    this.stripeData = this.modalData.dataObj;
    this.clientSecret = this.modalData.dataObj.clientSecret;
    this.setupIntentClientSecret =
      this.modalData.dataObj.setupIntentClientSecret;

    try {
      this.stripe = await loadStripe(environment.stripe_pub_key);
    } catch (error) {
      console.error('Error loading Stripe:', error);
      this.mode = 'noClientSecret'; // Or a specific error mode
      return;
    }

    if (!this.stripe) {
      console.error('Stripe.js failed to load.');
      this.mode = 'noClientSecret'; // Or a specific error mode
      return;
    }

    let clientSecretForElements: string | undefined;
    if (this.clientSecret) {
      console.log('Initializing for Payment Intent (clientSecret provided)');
      this.mode = 'payment';
      clientSecretForElements = this.clientSecret;
    } else if (this.setupIntentClientSecret) {
      console.log(
        'Initializing for Setup Intent (setupIntentClientSecret provided)'
      );
      this.mode = 'setup';
      clientSecretForElements = this.setupIntentClientSecret;
    } else {
      console.log('No clientSecret or setupIntentClientSecret found.');
      this.mode = 'noClientSecret';
    }
    this.cdr.detectChanges();

    if (
      (this.mode === 'payment' || this.mode === 'setup') &&
      clientSecretForElements
    ) {
      // It's often safer to wait for the next tick to ensure DOM is fully updated.
      // Using Promise.resolve().then() or setTimeout can help.
      Promise.resolve()
        .then(() => {
          if (this.stripe && clientSecretForElements) {
            // Re-check stripe due to closure
            console.log(
              `Attempting to mount Stripe Element for mode: ${this.mode}`
            );

            const paymentElementContainer = document.getElementById(
              'perennial-payment-element'
            );

            if (paymentElementContainer) {
              this.elements = this.stripe.elements({
                clientSecret: clientSecretForElements,
              });
              const paymentElement = this.elements.create('payment'); // 'payment' type element is used for both
              paymentElement.mount('#perennial-payment-element');
              console.log(
                `Successfully mounted Stripe Element for mode: ${this.mode}`
              );
            } else {
              console.error(
                `ERROR: #perennial-payment-element not found in DOM for mode: ${this.mode} even after mode assignment and tick.`
              );
            }
          }
        })
        .catch((error) => {
          console.error('Error in Promise for mounting Stripe element:', error);
        });
    } else if (this.mode !== 'noClientSecret') {
      console.error(
        `Stripe element will not be mounted. Mode: ${this.mode}, Client Secret for Elements: ${clientSecretForElements}`
      );
    }

    // if (this.stripe && this.clientSecret) {
    //   console.log('Stripe loaded and client secret is available', this.clientSecret, this.stripe);

    //   this.elements = this.stripe.elements({ clientSecret: this.clientSecret });
    //   const paymentElement = this.elements.create('payment');
    //   paymentElement.mount('#perennial-payment-element');
    // }
  }

  async handleSubmit(event: Event) {
    event.preventDefault();
    if (!this.stripe || !this.elements) return;

    this.isLoading = true;

    try {
      console.log('this.modalData.dataObj123', this.modalData.dataObj,this.modalData.dataObj.customer_id);
      console.log('this.cookieData', this.cookieData);

      let cookiebody = {
        customer_id: this.modalData.dataObj.customerId,
        subscription_id: this.modalData.dataObj.subscriptionId,
        user_id: this.modalData.dataObj.customer_id,
        email: this.modalData.dataObj.email,
        name: this.cookieData?.userinfo?.name,
      };

      this.cookieService.set(
        'perennialStripeUserDetails',
        JSON.stringify(cookiebody),
        { path: '/' }
      );

      
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/perennial-stripe-success-page`,
        },
        redirect: 'always',
      });

      if (error) {
        this.matSnackBar.open(
          `Payment failed: ${error.message || 'Unknown error'}`,
          '',
          { duration: 5000 }
        );
        this.isLoading = false;
      }
    } catch (e) {
      this.matSnackBar.open(
        'An unexpected error occurred. Please try again.',
        '',
        { duration: 5000 }
      );
      this.isLoading = false;
    }
    // this.dialogRef.close('success');
  }

  async handleSetupSubmit(event: Event) {
    console.log('handleSetupSubmit called');

    event.preventDefault();
    if (!this.stripe || !this.elements) return;

    this.isLoading = true;


     console.log('this.modalData.dataObj123', this.modalData.dataObj,this.modalData.dataObj.customer_id);
      console.log('this.cookieData', this.cookieData);

    let cookiebody = {
      customer_id: this.modalData.dataObj.customerId,
      subscription_id: this.modalData.dataObj.subscriptionId,
      user_id: this.modalData.dataObj.customer_id,
      email: this.modalData.dataObj.email,
      name: this.cookieData?.userinfo?.name,
    };
      console.log('cookiebody', cookiebody);

    this.cookieService.set(
      'perennialStripeUserDetails',
      JSON.stringify(cookiebody),
      { path: '/' }
    );

    const result = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: {
        return_url: `${window.location.origin}/perennial-stripe-success-page`,
      },
      redirect: 'always',
    });
  }
}
